// Line break insertion for the profile rich editor.

// True when anything that renders follows `node`, including content that sits
// after the end of its inline ancestors.
function hasRenderedContentAfter(node, root) {
  const after = document.createRange();
  after.setStartAfter(node);
  after.setEnd(root, root.childNodes.length);

  const content = after.cloneContents();
  return content.textContent.length > 0 || content.querySelector('*') !== null;
}

// Inserts a line break at the caret. A `<br>` that ends the content is not
// rendered by browsers, so a second trailing `<br>` is added as a sentinel to
// make the new line visible; the caret stays in front of it.
export function insertLineBreak(root) {
  const selection = window.getSelection();
  if (!root || !selection || selection.rangeCount === 0) return false;

  const range = selection.getRangeAt(0);
  if (!root.contains(range.commonAncestorContainer)) return false;

  range.deleteContents();

  const br = document.createElement('br');
  range.insertNode(br);

  if (!hasRenderedContentAfter(br, root) && br.parentNode) {
    br.parentNode.insertBefore(document.createElement('br'), br.nextSibling);
  }

  const caret = document.createRange();
  caret.setStartAfter(br);
  caret.collapse(true);
  selection.removeAllRanges();
  selection.addRange(caret);

  return true;
}
